import { Navigate } from "react-router-dom";
import { useClientProjectContext } from "../hooks/useClientRole";

/** Wraps route elements that should be blocked for client users. */
const ClientBlockGuard = ({ children }) => {
  const { isClientModeActive, currentProject, isLoading } =
    useClientProjectContext();

  if (isLoading) return null;

  if (isClientModeActive) {
    const fallback = currentProject
      ? `/projects/${currentProject.id}/tasks`
      : "/dashboard";
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default ClientBlockGuard;
